export default __webpack_public_path__ + "static/media/35.4caaee97.png";